import i18nInstance from 'i18n/i18nInstance'
import PropTypes from 'prop-types'
import { withI18nContext, useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import { Locations } from '@mc/track-event'
import EnterpriseCTA from 'components/EnterpriseCTA'
import PauseVideoScreen from './PauseVideoScreen'

const ContactSalesVideoScreen = ({ isSample, onCTAClick }) => {
  const { t } = useTranslation('@mc/next')
  const { skillCategory } = useStaticData()

  const captionTextKey = isSample
    ? 'course.details.sample'
    : 'course.details.trailer'

  return (
    <PauseVideoScreen
      captionText={t(captionTextKey)}
      actionText={t('skillCategoryPage.exploreSamples.pauseScreenActionText')}
      pricingText={t('skillCategoryPage.exploreSamples.pauseScreenContactText')}
      buttonGroup={
        <EnterpriseCTA
          className='mc-mt-8'
          pageSource={`MAW Skills:${skillCategory.name}`}
          location={Locations.VIDEO_PLAYER_PAUSE_SCREEN}
          onClick={onCTAClick}
          buttonText={t('skillCategoryPage.exploreSamples.pauseScreenCTA')}
          scrollToForm
          href='#contact-form'
        />
      }
    />
  )
}

ContactSalesVideoScreen.propTypes = {
  isSample: PropTypes.bool,
  onCTAClick: PropTypes.func,
}

export default withI18nContext(i18nInstance)(ContactSalesVideoScreen)
